import { styled } from "@mui/material/styles";

export const Container = styled("div", {
  label: "offer-bc-container",
})`
  @media print {
    display: none;
  }
`;
